import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { progressService } from "../../../../../../services/progressService";
// import { ArrowLeft, ArrowRight } from "lucide-react";
import stocai from "../../../../../../assets/Stocai.png";
import { UserContext } from "../../../../../../UserContext";
import ProfileCard from "./ProfileCard";
import CurrentYouForm from "./CurrentYouForm";
import CongratulationsPage from "./CompletionPages/CongratulationsPage";
import CurrentStateCard from "./CompletionPages/CurrentStateCard";
import MilestoneAnimation from "./CompletionPages/MilestoneAnimation";
import FutureCardPrompt from "./CompletionPages/FutureCardPrompt";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";

const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL || "http://localhost:8000";

// Normalize stored data to a flat payload (strip nested type/payload wrappers)
const normalizePayload = (data) => {
  if (!data) return {};
  if (data.payload?.payload) return data.payload.payload; // double-nested
  if (data.payload) return data.payload; // single-nested
  const { payload: _payload, type: _type, ...rest } = data; // strip wrappers if present
  return rest;
};

const CurrentYou = ({ subsectionId, legacySubsectionId, onReadyChange, initialData }) => {
  const [subStep, setSubStep] = useState(1);
  const [essentialsField, setEssentialsField] = useState(0);
  const [completionStep, setCompletionStep] = useState(0);
  // const [formData, setFormData] = useState({
  //   profileImage: null,
  //   userName: "",
  //   currentTitle: "",
  //   company: "",
  //   location: "",
  //   salary: "",
  //   totalExperience: "",
  //   experienceYears: "",
  //   experienceMonths: "",
  //   technicalSkills: "",
  //   behaviors: "",
  //   advice: "",
  //   hobbies: "",
  //   futureNote: "",
  //   futureVoiceNote: null,
  // });
  // const [isLoading, setIsLoading] = useState(false);
  // ✅ Start with null formData and true loading state
  const [formData, setFormData] = useState(() => {
    const cached = localStorage.getItem("currentYouFormData");
    return cached ? normalizePayload(JSON.parse(cached)) : {};
  });
  const [isLoading, setIsLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const requestTimestampRef = useRef(0);

  const { user } = useContext(UserContext);
  const userId = user?.user_id;
  const userName = user?.firstName && user?.lastName 
    ? `${user.firstName} ${user.lastName}` 
    : (user?.firstName || user?.lastName || "");

  // useEffect(() => {
  //   if (userName && !formData.userName) {
  //     setFormData(prev => ({
  //       ...prev,
  //       userName: userName
  //     }));
  //   }
  // }, [userName, formData.userName]);

  useEffect(() => {
  if (userName && (!formData || !formData.userName)) {
    setFormData((prev) => ({
      ...(prev || {}),
      userName: userName,
    }));
  }
}, [userName, formData]);


  const isValidUUID = (uuid) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
  };

  // const loadProgress = useCallback(async () => {
  //   if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
  //     console.log("Skipping progress load - invalid or missing subsectionId");
  //     return;
  //   }
    
  //   try {
  //     let record = await progressService.getUserProgress(userId, subsectionId);
  //     if (!record && legacySubsectionId && isValidUUID(legacySubsectionId)) {
  //       // Fallback: try legacy subsection id used previously
  //       record = await progressService.getUserProgress(userId, legacySubsectionId);
  //     }
  //     const data = record?.data;
  //     if (data) {
  //       setFormData((prev) => ({ ...prev, ...data }));
  //     }
  //   } catch (err) {
  //     console.error("Failed to load progress:", err);
  //   }
  // }, [userId, subsectionId, legacySubsectionId]);

const loadProgress = useCallback(async () => {
  if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
    console.warn("Skipping load – invalid or missing subsectionId");
    setIsLoading(false);
    return;
  }

  const currentRequestTime = Date.now();
  requestTimestampRef.current = currentRequestTime;

  try {
    let record = await progressService.getUserProgress(userId, subsectionId);

    // fallback if using legacy id
    if (!record && legacySubsectionId && isValidUUID(legacySubsectionId)) {
      record = await progressService.getUserProgress(userId, legacySubsectionId);
    }

    const data = normalizePayload(record?.data);
    if (data && Object.keys(data).length > 0 && currentRequestTime >= requestTimestampRef.current) {
      console.log("✅ Loaded user data:", data);
      setFormData((prev) => {
        const merged = { ...(prev || {}), ...data };
        localStorage.setItem("currentYouFormData", JSON.stringify(merged));
        return merged;
      });
    } else {
      console.log("⚠️ No data from API or keeping cached version");
    }
  } catch (err) {
    console.error("❌ Failed to load progress:", err);
    setError("Could not load your data. Please refresh.");
  } finally {
    setIsLoading(false);
  }
}, [userId, subsectionId, legacySubsectionId]);


// ✅ LOAD PROGRESS safely (protect from stale GETs)
// const loadProgress = useCallback(async () => {
//   if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
//     console.warn("Skipping load – invalid or missing subsectionId");
//     setIsLoading(false);
//     return;
//   }

//   const currentRequestTime = Date.now();
//   requestTimestampRef.current = currentRequestTime;

//   try {
//     let record = await progressService.getUserProgress(userId, subsectionId);

//     // fallback if using legacy id
//     if (!record && legacySubsectionId && isValidUUID(legacySubsectionId)) {
//       record = await progressService.getUserProgress(userId, legacySubsectionId);
//     }

//     const data = record?.data;
//     if (data && currentRequestTime >= requestTimestampRef.current) {
//       console.log("✅ Loaded user data:", data);
//       setFormData((prev) => ({ ...(prev || {}), ...data }));
//     }
//   } catch (err) {
//     console.error("❌ Failed to load progress:", err);
//     setError("Could not load your data. Please refresh.");
//   } finally {
//     setIsLoading(false);
//   }
// }, [userId, subsectionId, legacySubsectionId]);


//   useEffect(() => {
//     // Hydrate from initialData first if provided
//     if (initialData && typeof initialData === 'object') {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//     }
//     if (userId && subsectionId && isValidUUID(subsectionId)) {
//       loadProgress();
//     }
//   }, [userId, subsectionId, loadProgress, initialData]);

//   useEffect(() => {
//   let didCancel = false; // flag to cancel old async operations

//   const init = async () => {
//     if (initialData && typeof initialData === 'object') {
//       setFormData((prev) => ({ ...prev, ...initialData }));
//     }

//     if (userId && subsectionId && isValidUUID(subsectionId)) {
//       try {
//         await loadProgress();
//       } catch (err) {
//         if (!didCancel) console.error("Init load error:", err);
//       }
//     }
//   };

//   init();
//   return () => { didCancel = true; };
// }, [userId, subsectionId, loadProgress, initialData]);

  // ✅ Single clean initial data load
  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      if (initialData && typeof initialData === "object") {
        setFormData((prev) => ({ ...(prev || {}), ...normalizePayload(initialData) }));
      }

      await loadProgress();
      if (!cancelled) setIsLoading(false);
    };

    init();

    return () => {
      cancelled = true;
    };
  }, [userId, subsectionId, initialData, loadProgress]);


  // const saveProgress = async (status = "in_progress") => {
  //   if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
  //     console.log("Skipping progress save - invalid or missing subsectionId");
  //     return;
  //   }

  //   setIsLoading(true);
  //   setError(null);

  //   try {
  //     // const result = await progressService.saveProgress(
  //     //   userId,
  //     //   subsectionId,
  //     //   formData,
  //     //   status
  //     // );
  //         const dataToSave = {
  //       ...formData,
  //       step: subStep,  // Main substep (1, 2, or 3)
  //       essentialsField: essentialsField  // Micro-step within Essentials (0-4)
  //     };
      
  //     const result = await progressService.saveProgress(
  //       userId,
  //       subsectionId,
  //       dataToSave,  // Changed from formData to dataToSave
  //       status
  //     );

  //     console.log("Progress saved successfully:", result);
  //     return result;
  //   } catch (err) {
  //     setError("Failed to save progress. Please try again.");
  //     console.error("Save progress error:", err);
  //     throw err;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // const saveProgress = async (status = "in_progress") => {
  //   if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
  //     console.log("Skipping progress save - invalid or missing subsectionId");
  //     return;
  //   }

  //   setIsLoading(true);
  //   setError(null);

  //   const currentSaveTime = Date.now();
  //   requestTimestampRef.current = currentSaveTime; // mark this POST as newest

  //   try {
  //     const dataToSave = {
  //       ...formData,
  //       step: subStep,
  //       essentialsField: essentialsField,
  //     };

  //     const result = await progressService.saveProgress(
  //       userId,
  //       subsectionId,
  //       dataToSave,
  //       status
  //     );

  //     console.log("Progress saved successfully:", result);
  //     return result;
  //   } catch (err) {
  //     setError("Failed to save progress. Please try again.");
  //     console.error("Save progress error:", err);
  //     throw err;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


  // const handleInputChange = (field, value) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // ✅ Protects from null formData on first render
  
// const saveProgress = async (status = "in_progress") => {
//   if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
//     console.warn("Skipping progress save - invalid or missing subsectionId");
//     return;
//   }

//   setIsLoading(true);
//   setError(null);

//   try {
//     // ✅ Only the actual payload
//     const payload = {
//       type: "widget",
//       payload: {
//         ...formData, // includes image, title, etc.
//       },
//     };

//     const result = await progressService.saveProgress(
//       userId,
//       subsectionId,
//       payload, // ✅ send this directly
//       status
//     );

//     console.log("✅ Progress saved successfully:", result);

//     // Cache locally
//     localStorage.setItem("currentYouFormData", JSON.stringify(formData));

//     return result;
//   } catch (err) {
//     console.error("❌ Save progress error:", err);
//     setError("Failed to save progress. Please try again.");
//   } finally {
//     setIsLoading(false);
//   }
// };

const saveProgress = async (status = "in_progress") => {
  if (!userId || !subsectionId || !isValidUUID(subsectionId)) {
    console.warn("Skipping progress save - invalid or missing subsectionId");
    return;
  }

  setIsLoading(true);
  setError(null);

  try {
    const cleanFormData = normalizePayload(formData);
    const payload = {
      type: "widget",
      payload: { ...cleanFormData },
    };

    const result = await progressService.saveProgress(
      userId,
      subsectionId,
      payload,
      status
    );

    console.log("Progress saved successfully:", result);
    localStorage.setItem("currentYouFormData", JSON.stringify(cleanFormData)); // keep in sync

    return result;
  } catch (err) {
    console.error("❌ Save progress error:", err);
    setError("Failed to save progress. Please try again.");
  } finally {
    setIsLoading(false);
  }
};
  
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...(prev || {}), [field]: value }));
  };


  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    if (!userId) {
      setError("User not authenticated");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError("File size must be less than 5MB");
      return;
    }

    setUploading(true);
    setError(null);

    try {
      console.log("Starting upload for user:", userId);
      
      const uploadUrlResponse = await fetch(`${apiBaseURL}/upload-url`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          user_id: userId, 
          filename: file.name,
          minutes_valid: 15
        }),
      });

      if (!uploadUrlResponse.ok) {
        const errorData = await uploadUrlResponse.json().catch(() => ({}));
        throw new Error(errorData.detail || "Failed to get upload URL");
      }

      const { uploadUrl, blobName } = await uploadUrlResponse.json();
      console.log("Got upload URL for blob:", blobName);

      const azureUploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        headers: { 
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": file.type
        },
        body: file,
      });

      if (!azureUploadResponse.ok) {
        throw new Error(`Azure upload failed: ${azureUploadResponse.status}`);
      }

      console.log("File uploaded to Azure successfully");

      const readUrlResponse = await fetch(
        `${apiBaseURL}/read-url?blob_name=${encodeURIComponent(blobName)}`
      );

      if (!readUrlResponse.ok) {
        throw new Error("Failed to get read URL");
      }

      const { readUrl } = await readUrlResponse.json();
      console.log("Got read URL:", readUrl);

      handleInputChange("profileImage", readUrl);
      
    } catch (err) {
      setError(err.message || "Failed to upload image. Please try again.");
      console.error("Image upload error:", err);
    } finally {
      setUploading(false);
    }
  };

  const handleVoiceUpload = async (audioBlob) => {
    if (!userId) {
      setError("User not authenticated");
      return;
    }

    setUploading(true);
    setError(null);

    try {
      console.log("Starting voice upload for user:", userId);
      
      const timestamp = Date.now();
      const filename = `voice_note_${timestamp}.webm`;
      
      const uploadUrlResponse = await fetch(`${apiBaseURL}/upload-url`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          user_id: userId, 
          filename: filename,
          minutes_valid: 15
        }),
      });

      if (!uploadUrlResponse.ok) {
        const errorData = await uploadUrlResponse.json().catch(() => ({}));
        throw new Error(errorData.detail || "Failed to get upload URL");
      }

      const { uploadUrl, blobName } = await uploadUrlResponse.json();
      console.log("Got upload URL for blob:", blobName);

      const azureUploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        headers: { 
          "x-ms-blob-type": "BlockBlob",
          "Content-Type": "audio/webm"
        },
        body: audioBlob,
      });

      if (!azureUploadResponse.ok) {
        throw new Error(`Azure upload failed: ${azureUploadResponse.status}`);
      }

      console.log("Voice uploaded to Azure successfully");

      const readUrlResponse = await fetch(
        `${apiBaseURL}/read-url?blob_name=${encodeURIComponent(blobName)}`
      );

      if (!readUrlResponse.ok) {
        throw new Error("Failed to get read URL");
      }

      const { readUrl } = await readUrlResponse.json();
      console.log("Got read URL:", readUrl);

      handleInputChange("futureVoiceNote", readUrl);
      
    } catch (err) {
      setError(err.message || "Failed to upload voice note. Please try again.");
      console.error("Voice upload error:", err);
    } finally {
      setUploading(false);
    }
  };

  // Handle navigation within Essentials substep
  const handleEssentialsNext = async () => {
    if (essentialsField < 4) {  // 5 fields total (0-4)
      // Save progress before moving to next field
      await saveProgress("in_progress");
      setEssentialsField(essentialsField + 1);
    }
  };

  const handleEssentialsBack = async () => {
    if (essentialsField > 0) {
      // Save progress before moving to previous field
      await saveProgress("in_progress");
      setEssentialsField(essentialsField - 1);
    }
  };

  // Reset essentialsField when entering/leaving Essentials substep
  useEffect(() => {
    if (subStep === 1) {
      // Stay on current essentialsField
    } else {
      setEssentialsField(0); // Reset when leaving Essentials
    }
  }, [subStep]);

  // Updated handleNext to handle Essentials micro-navigation
const handleNext = async () => {
  console.log("Handling next from subStep:", subStep, "essentialsField:", essentialsField);

  if (!isStepComplete()) {
    setError("Please complete all required fields");
    return;
  }

  try {
    setError(null);

    // Special handling for Essentials substep
    if (subStep === 1 && formData?.profileImage && essentialsField < 4) {
      // Still navigating within Essentials fields
      await handleEssentialsNext();
      return;
    }

    // Save progress before moving to next main substep
    const status = subStep === 3 ? "completed" : "in_progress";
    await saveProgress(status);

    if (subStep < 3) {
      setSubStep(subStep + 1);
      setEssentialsField(0); // Reset essentials field when moving to next substep
    } else {
      setCompletionStep(1);
    }
  } catch (err) {
    console.error("Error in handleNext:", err);
  }
};

// Updated handleBack to handle Essentials micro-navigation
const handleBack = async () => {
  try {
    // Special handling for Essentials substep
    if (subStep === 1 && formData?.profileImage && essentialsField > 0) {
      // Still navigating within Essentials fields
      await handleEssentialsBack();
      return;
    }

    // Move to previous main substep
    if (subStep > 1) {
      await saveProgress("in_progress");
      setSubStep(subStep - 1);
      setError(null);
    }
  } catch (err) {
    console.error("Error in handleBack:", err);
  }
};

  // const isStepComplete = () => {
  //   switch (subStep) {
  //     case 1:
  //       // Check if profile image is uploaded first
  //       if (!formData.profileImage) {
  //         return false;
  //       }
        
  //       // Check individual essentials fields based on current field
  //       const essentialsQuestions = [
  //         { id: "currentTitle" },
  //         { id: "company" },
  //         { id: "location" },
  //         { id: "salary" },
  //         { id: "totalExperience" }
  //       ];
        
  //       // Check if current field is filled
  //       const currentField = essentialsQuestions[essentialsField];
  //       if (currentField && !formData[currentField.id]) {
  //         return false;
  //       }
        
  //       // If on last field, check all fields are complete
  //       if (essentialsField === 4) {
  //         return !!(
  //           formData.profileImage &&
  //           formData.currentTitle &&
  //           formData.company &&
  //           formData.location &&
  //           formData.salary &&
  //           formData.totalExperience
  //         );
  //       }
        
  //       return true; // Current field is complete
  //     case 2:
  //       return !!(
  //         formData.technicalSkills &&
  //         formData.behaviors &&
  //         formData.advice &&
  //         formData.hobbies
  //       );
  //     case 3:
  //       return !!formData.futureVoiceNote;
  //     default:
  //       return false;
  //   }
  // };

//   const isStepComplete = () => {
//   if (subStep === 1) {
//     if (!formData.profileImage) return false;
//     if (essentialsField === 0 && !formData.currentTitle?.trim()) return false;
//     if (essentialsField === 1 && !formData.company?.trim()) return false;
//     if (essentialsField === 2 && !formData.location?.trim()) return false;
//     if (essentialsField === 3 && !formData.salary) return false;
    
//     // ⬇️⬇️⬇️ YEH SECTION ADD KARO ⬇️⬇️⬇️
//     if (essentialsField === 4) {
//       const yearsFilled = formData.experienceYears !== "" && 
//                          formData.experienceYears !== null && 
//                          formData.experienceYears !== undefined;
      
//       const monthsFilled = formData.experienceMonths !== "" && 
//                           formData.experienceMonths !== null && 
//                           formData.experienceMonths !== undefined;
      
//       return yearsFilled || monthsFilled;
//     }
//     // ⬆️⬆️⬆️ YEH SECTION ADD KARO ⬆️⬆️⬆️
    
//     return true;
//   }

//   if (subStep === 2) {
//     return (
//       formData.technicalSkills?.trim() ||
//       formData.behaviors?.trim() ||
//       formData.advice?.trim() ||
//       formData.hobbies?.trim()
//     );
//   }

//   if (subStep === 3) {
//     return formData.futureVoiceNote !== null;
//   }

//   return false;
// };

  const isStepComplete = () => {
  // if (!formData) return false; // 🛡️ Prevent null access

  if (subStep === 1) {
    if (!formData?.profileImage) return false;
    if (essentialsField === 0 && !formData?.currentTitle?.trim()) return false;
    if (essentialsField === 1 && !formData?.company?.trim()) return false;
    if (essentialsField === 2 && !formData?.location?.trim()) return false;
    if (essentialsField === 3 && !formData?.salary) return false;

    if (essentialsField === 4) {
      const yearsFilled =
        formData?.experienceYears !== "" &&
        formData?.experienceYears !== null &&
        formData?.experienceYears !== undefined;

      const monthsFilled =
        formData?.experienceMonths !== "" &&
        formData?.experienceMonths !== null &&
        formData?.experienceMonths !== undefined;

      return yearsFilled || monthsFilled;
    }

    return true;
  }

  if (subStep === 2) {
    return (
      formData?.technicalSkills?.trim() ||
      formData?.behaviors?.trim() ||
      formData?.advice?.trim() ||
      formData?.hobbies?.trim()
    );
  }

  if (subStep === 3) {
    return !!formData?.futureVoiceNote;
  }

  return false;
};


  // Added function to get dynamic button text based on substep
  // const getButtonText = () => {
  //   if (isLoading) return "Saving...";
  //   if (uploading) return "Uploading...";
    
  //   if (subStep === 1) {
  //     // Within Essentials, show different text based on field
  //     if (!formData.profileImage) {
  //       return (
  //         <>
  //         <div className="flex items-center justify-between gap-4">
  //           Continue
  //           <FaChevronCircleRight className="w-4 h-4" />
  //         </div>
  //         </>
  //       );
  //     } else if (essentialsField < 4) {
  //       return (
  //         <>
  //         <div className="flex items-center justify-between gap-4">
  //           Next Step
  //           <FaChevronCircleRight className="w-4 h-4" />
  //           </div>
  //         </>
  //       );
  //     } else {
  //       return (
  //         <>
  //         <div className="flex items-center justify-between gap-4">
  //           Next Step: Known For
  //           <FaChevronCircleRight className="w-4 h-4" />
  //           </div>
  //         </>
  //       );
  //     }
  //   } else if (subStep === 2) {
  //     return (
  //       <>
  //         <div className="flex items-center justify-between gap-4">
  //             Next Step: Future Note
  //         <FaChevronCircleRight className="w-4 h-4 mt-2 flex justify-center items-center" />
  //         </div>
  //       </>
  //     );
  //   } else if (subStep === 3) {
  //     return (
  //       <>
  //         <div className="flex items-center justify-between gap-4">
  //         Complete Current Card
  //         <FaChevronCircleRight className="w-4 h-4" />
  //         </div>
  //       </>
  //     );
  //   }
  //   return (
  //     <>
  //     <div className="flex items-center justify-between gap-4">
  //       Next
  //       <FaChevronCircleRight className="w-4 h-4" />
  //       </div>
  //     </>
  //   );

  // };

  // Notify parent when all internal steps are completed (ready to proceed)
  useEffect(() => {
    onReadyChange?.(completionStep >= 4);
  }, [completionStep, onReadyChange]);

// 🧠 Restore cached data instantly on first load
useEffect(() => {
  const cachedData = localStorage.getItem("currentYouFormData");
  if (cachedData) {
    console.log("🔁 Restoring formData from cache");
    setFormData(normalizePayload(JSON.parse(cachedData)));
  }
}, []);

// // 🧠 Keep cache updated every time formData changes
// useEffect(() => {
//   if (Object.keys(formData || {}).length > 0) {
//     localStorage.setItem("currentYouFormData", JSON.stringify(formData));
//   }
// }, [formData]);

// useEffect(() => {
//   if (completionStep === 4) {
//     localStorage.removeItem("currentYouFormData");
//   }
// }, [completionStep]);

// 🧠 Keep cache updated in real-time
useEffect(() => {
  if (formData && Object.keys(formData).length > 0) {
    localStorage.setItem("currentYouFormData", JSON.stringify(normalizePayload(formData)));
  }
}, [formData]);

// 🧠 Clear cache when finished completely
useEffect(() => {
  if (completionStep === 4) {
    localStorage.removeItem("currentYouFormData");
  }
}, [completionStep]);



    // ✅ Show loader until data is fetched
// if (isLoading || !formData) {
//   return (
//     <div className="flex justify-center items-center h-full">
//       <p className="text-gray-500 text-lg font-medium">Loading your profile...</p>
//     </div>
//   );
// }


  if (completionStep === 1) {
    return <CongratulationsPage formData={formData} onContinue={() => setCompletionStep(2)} />;
  }
  
  if (completionStep === 2) {
    return <CurrentStateCard formData={formData} onContinue={() => setCompletionStep(3)} />;
  }
  
  if (completionStep === 3) {
    return <MilestoneAnimation onComplete={() => setCompletionStep(4)} />;
  }
  
  if (completionStep === 4) {
    return <FutureCardPrompt formData={formData} hideContinue />;
  }

  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-full flex flex-col">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:items-stretch">
          <ProfileCard formData={formData} onInputChange={handleInputChange} />

          <div className="lg:col-span-8 flex flex-col">
            <div className="bg-white rounded-2xl shadow-md flex-1 flex flex-col">
              <div className="p-6 md:p-8">
                <h1 className="text-2xl font-medium font-gotham text-gray-900">
                  Map Your Reality – Current You
                </h1>
              </div>

              <div className="p-6 md:p-8">
                <div className="flex items-center justify-between mb-8 relative max-w-full mx-auto -translate-x-4">
                  <div className="absolute top-3.5 left-0 right-0 h-[3.5px] bg-[#E3E3E3]" />
                  <div
                    className="absolute top-3.5 left-0 h-[3.5px] bg-[#54B0AF] transition-all duration-500"
                    style={{ width: subStep === 1 ? '0%' : subStep === 2 ? '50%' : '100%' }}
                  />

                  {[
                    { num: 1, label: "Essentials" },
                    { num: 2, label: "Known For" },
                    { num: 3, label: "Future Note" }
                  ].map((step) => (
                    <div key={step.num} className="flex flex-col items-center relative bg-white z-10">
                      <div
                        className={`w-7 h-7 rounded-full font-gotham flex items-center justify-center text-xs lg:text-[16px] transition-all ${
                          subStep >= step.num
                            ? "bg-[#54B0AF] text-white font-bold"
                            : "bg-white border-2 border-[#E3E3E3] text-[#888888] font-medium"
                        }`}
                      >
                        {subStep > step.num ? (
                          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        ) : (
                          step.num
                        )}
                      </div>
                      <span className={`mt-2 text-xs lg:text-[12px] font-bold font-gotham uppercase whitespace-nowrap translate-x-6 ${
                        subStep >= step.num ? "text-[#54B0AF]" : "text-[#888888]"
                      }`}>
                        {step.label}
                      </span>
                    </div>
                  ))}
                </div>


                {error && (
                  <div className="mb-6 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                  </div>
                )}

                <div className="flex items-start gap-4">
                  <img src={stocai} alt="Coach" className="w-12 h-12 md:w-16 md:h-16 rounded-full flex-shrink-0" />
                  <div className="flex-1">
                    <CurrentYouForm
                      formData={formData}
                      subStep={subStep}
                      essentialsField={essentialsField}
                      setEssentialsField={setEssentialsField}
                      uploading={uploading}
                      onInputChange={handleInputChange}
                      onImageUpload={handleImageUpload}
                      onVoiceUpload={handleVoiceUpload}
                      onEssentialsNext={handleEssentialsNext}
                    />
                  </div>
                </div>
              </div>

              {/* commented code */}

           
            </div>

         {/* Updated button section - shows back even in Essentials */}
            <div className="px-6 md:px-8 py-6 border-t border-gray-100 flex justify-between items-center">
              {/* Left side - Main action button */}
              <div className="flex items-center gap-2">
                {/* <button
                  onClick={handleNext}
                  disabled={isLoading || !isStepComplete() || uploading}
                  className="inline-flex items-center gap-3 px-6 py-3 font-gotham bg-[#54B0AF] text-white rounded-full hover:bg-[#449e9d] font-medium transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  {isLoading ? (
                    <>
                      <span className="animate-spin">⏳</span>
                      <span>Saving...</span>
                    </>
                  ) : uploading ? (
                    <>
                      <span className="animate-spin">⏳</span>
                      <span>Uploading...</span>
                    </>
                  ) : (
                    <span className="flex gap-2">{getButtonText()}</span>
                  )}
                </button> */}
              </div>

              {/* Center - Loading status */}
              <div className="flex-1 text-center">
                {/* {isLoading && (
                  <p className="text-sm text-gray-500">Saving your progress...</p>
                )} */}
              </div>

              {/* Right side - Navigation buttons (up/down) */}
              <div className="flex items-center gap-2">
                <button
                  onClick={handleBack}
                  disabled={subStep === 1 && (!formData.profileImage || essentialsField === 0)}
                  className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  <FaChevronUp className="w-4 h-4 font-gotham -rotate-90 text-white" />
                </button>

                <button
                  onClick={handleNext}
                  disabled={isLoading || !isStepComplete() || uploading}
                  className="inline-flex items-center gap-2 px-2 py-2 font-gotham bg-[#B6B6B6] rounded-full hover:bg-[#54B0AF] font-medium transition-all disabled:opacity-30"
                >
                  <FaChevronDown className="w-4 h-4 font-gotham -rotate-90 text-white" />
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentYou;
